import React from "react";

const team = [
  { name: "Prasad", role: "Growth Strategist" },
  { name: "Sha", role: "social media strategist" },
  // { name: "Maya Chen", role: "Performance Lead" },
];

export default function AboutSection() {
  return (
    <section className="about" id="about">
      <div className="section-inner">
        <div className="about-header">
          <p className="section-tag">About Us</p>
          <h2>Small, senior, and obsessed with outcomes.</h2>
          <p className="section-lead">
            We are a compact team of strategists, creatives, and performance
            marketers focused on modern brands and fast-moving founders.
          </p>
        </div>
        <div className="team-grid">
          {team.map((member) => (
            <div className="team-card" key={member.name}>
              <div className="avatar"></div>
              <div>
                <strong>{member.name}</strong>
                <span>{member.role}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
